module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-3000-Classes-Inactive-abe3adccf203461721395f3c374216bf.png";